import styled from "styled-components"

const BurgerSpan = styled.span`
  background: ${(props) => props.theme.c_color_gradients.c_dark};
`

const MenuTitle = styled.p`
  color: ${(props) => props.theme.c_color_gradients.c_dark};
`

const LogoSite = styled.div`
  & svg,
  & path {
    fill: ${(props) => props.theme.b_color_gradients.b_dark}!important;
  }
`

export { BurgerSpan, LogoSite, MenuTitle }
